module.exports = __webpack_public_path__ + "static/media/json-file.2548cf42.svg";